import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import {
  HeaderComponent,
  HelpComponent,
  TitleComponent,
  MessageComponent,
  CardComponent
} from '.';


@NgModule({
  declarations: [
    HeaderComponent,
    HelpComponent,
    TitleComponent,
    MessageComponent,
    CardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule,
    HeaderComponent,
    HelpComponent,
    TitleComponent,
    MessageComponent,
    CardComponent
  ]
})
export class ComponentsModule { }
